import React from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { useOpenOfficialMatch } from "@/hooks/useOpenOfficialMatch";
import { resolveShellRoute } from "@/lib/shellRoutes";

export default function ShellRouteBridge() {
  const location = useLocation();
  const navigate = useNavigate();
  const shellRoute = React.useMemo(
    () => resolveShellRoute(location.pathname),
    [location.pathname]
  );
  const openOfficialMatch = useOpenOfficialMatch({
    enabled: shellRoute?.type === "official_match",
  });
  const lastHandledRef = React.useRef("");

  React.useEffect(() => {
    const currentUrl = `${location.pathname}${location.search}${location.hash}`;
    if (lastHandledRef.current === currentUrl) return;

    if (!shellRoute) return;

    lastHandledRef.current = currentUrl;

    if (shellRoute.type === "official_match") {
      void openOfficialMatch(shellRoute.officialId).then((destination) => {
        if (destination === "saved_protocol") return;
        navigate(shellRoute.fallbackPath, {
          replace: true,
          state: {
            shellRedirectedFrom: currentUrl,
          },
        });
      });
    }
  }, [location.hash, location.pathname, location.search, navigate, openOfficialMatch, shellRoute]);

  return null;
}
